import React from 'react';
import { GamingWidgetButtonWrapper, GamingWidgetStyledButton } from './styled-components';
import { handleOnButtonClick } from '../../utils';
export const GamingWidgetButton = ({ ctaText, navigation }) => {
    const { type, url, messageBusTopic, messageBusValue } = navigation;
    const buttonAttributes = type === 'url' ? { href: url } : { onClick: () => handleOnButtonClick(messageBusTopic, messageBusValue) };
    return (React.createElement(GamingWidgetButtonWrapper, null,
        React.createElement(GamingWidgetStyledButton, Object.assign({ "data-testid": "ButtonText" }, buttonAttributes), ctaText)));
};
